/**
 * @create date 2022-06-07 16:49:07
 * @modify date 2021-06-07 16:49:07
 * @desc 海报
 */
import { computed } from "mobx";
import { EnumAPI } from "../../apis";
import { AjaxBasics } from "../../helpers";
import { BaseModel, BasesController } from "../bases";
import lodash from "lodash";
export class PosterController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: "posterId",
      infinite: true,
      pagination: EnumAPI.content_detail_myposters,
    });
  }
  readonly SearchParams = new SearchParams({
    storageKey: "poster_search_params",
  });
  /**
   * 获取活动海报
   * @memberof
   */
  async getActivityType(body) {
    const ThemeTabs = await AjaxBasics.requestEnum(
      lodash.merge({ body }, EnumAPI.content_activity_myposters),
      { labelKey: "actTitle", valueKey: "promoId" }
    );
    this.SearchParams.merge({ ThemeTabs });
  }
  /**
   * 获取推广海报
   * @memberof
   */
  async getPromoteType(body) {
    const ThemeTabs = await AjaxBasics.requestEnum(
      lodash.merge({ body }, EnumAPI.content_promote_myposters),
      { labelKey: "title", valueKey: "promoId" }
    );
    this.SearchParams.merge({ ThemeTabs });
  }
  /**
   * 获取类型下对应的海报
   * @return {*}
   * @memberof PosterController
   */
  async getMyposter(body) {
    const PosterList = await AjaxBasics.request({
      ...EnumAPI.content_detail_myposters,
      body,
    });
    this.SearchParams.merge({ PosterList });
  }
  /**
   * 获取海报回流数据
   * @return {*}
   * @memberof PosterController
   */
  async getPosterShareLog(id) {
    return AjaxBasics.request({
      ...EnumAPI.content_poster_shareLog,
      body: { id },
    });
  }
  /**
   * 获取海报活动回流数据
   * @return {*}
   * @memberof PosterController
   */
  async getPosterActivityShareLog(id) {
    return AjaxBasics.request({
      ...EnumAPI.content_poster_activity_shareLog,
      body: { id },
    });
  }
  /**
   * 当前轮播索引
   * @return {*}
   * @memberof PosterController
   */
  setActiveIndex(ActiveIndex) {
    this.SearchParams.merge({ ActiveIndex });
  }
  /**
   * 当前主题详情
   * @return {*}
   * @memberof PosterController
   */
  setThemInfo(detailThemInfo) {
    const info = lodash.has(detailThemInfo, "original")
      ? detailThemInfo.original
      : {};
    this.SearchParams.merge({ detailThemInfo: info });
  }
}
class SearchParams extends BaseModel {
  /**
   * 顶部 tab
   */
  get posterTabType() {
    return [
      { label: "活动海报", value: "0" },
      { label: "推广海报", value: "1" },
    ];
  }
  /**
   * 模板 - 活动类型
   */
  posterTypeArray(type) {
    const AllType = {
      0: "",
      1: "直播活动",
      2: "页面活动",
      3: "ISG推广活动",
    };
    return AllType[type];
  }
  @computed
  get ThemeTabs() {
    return this.value?.ThemeTabs || [];
  }
  @computed
  get PromoteTabs() {
    return this.value?.PromoteTabs || [];
  }
  @computed
  get ActiveIndex() {
    return this.value?.ActiveIndex || 0;
  }
  @computed
  get PosterList() {
    return this.value?.PosterList || [];
  }
  @computed
  get detailThemInfo() {
    return this.value?.detailThemInfo || {};
  }
}
